import { render, staticRenderFns } from "./SafetyHealthDetail.vue?vue&type=template&id=80e0976c&scoped=true"
import script from "./SafetyHealthDetail.vue?vue&type=script&lang=js"
export * from "./SafetyHealthDetail.vue?vue&type=script&lang=js"
import style0 from "./SafetyHealthDetail.vue?vue&type=style&index=0&id=80e0976c&prod&scoped=true&lang=css"
import style1 from "./SafetyHealthDetail.vue?vue&type=style&index=1&id=80e0976c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e0976c",
  null
  
)

export default component.exports